import React, { useEffect } from "react";
import { connect } from "react-redux";

import { Select } from "../Select";
import { getDocumentCategories } from "../../../actions/companyActions";
import { useCurrentCompany, useCurrentCompanyValue } from "hooks/auth";

export const DocumentCategoryComponent = ({
	name,
	options,
	setFieldValue,
	defaultValue,
	label,
	required,
	values,
	getDocumentCategories,
	testId,
	disabled,
	...props
}) => {
	const profileType = useCurrentCompanyValue("profile_type");

	useEffect(() => {
		getDocumentCategories(profileType?.id || "");
	}, [getDocumentCategories, profileType?.id]);

	let optionsArray = [];
	if (options.length) {
		optionsArray = options
			.filter((o) => o.parent_id === 0 && o.id !== 8)
			.map((option) => ({ value: option.id, label: option.name }));
	}

	let value = optionsArray.find(
		(option) => option.value === parseInt(values[name])
	);

	return (
		<Select
			label={label || "Category"}
			required={required}
			options={optionsArray}
			name={name}
			setFieldValue={setFieldValue}
			value={value}
			className={props.className}
			testId={testId}
			disabled={disabled}
		/>
	);
};

const mapStateToProps = (state) => {
	return {
		options: state.companyProfile.documentCategories,
	};
};

export const DocumentCategory = connect(mapStateToProps, {
	getDocumentCategories,
})(DocumentCategoryComponent);
